/**
 * Selector de idioma de la interfaz.
 *
 * Cambia solo la interfaz: el PDF del DeCA se genera siempre en español, porque
 * es el documento que se presenta a la inspección española (apdo. 9.4).
 */

import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import type { SxProps, Theme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { IDIOMAS, cambiarIdioma } from '../i18n'

/**
 * `sx` permite adaptarlo al fondo donde se coloca: sobre la barra oscura del
 * back-office necesita texto claro para verse (por defecto el texto es oscuro,
 * correcto sobre la tarjeta clara del acceso y la cabecera de salidas).
 */
export function SelectorIdioma({ sx }: { sx?: SxProps<Theme> }) {
  const { i18n } = useTranslation()
  return (
    <TextField
      select
      size="small"
      value={i18n.resolvedLanguage ?? 'es'}
      onChange={(evento) => cambiarIdioma(evento.target.value)}
      sx={[{ minWidth: 130 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      {IDIOMAS.map((idioma) => (
        <MenuItem key={idioma.codigo} value={idioma.codigo}>
          {idioma.nombre}
        </MenuItem>
      ))}
    </TextField>
  )
}
